import { gql } from '@apollo/client'

export const REJECT_TEST_SESSION = gql`
  mutation RejectTestSession($inputData: RejectTestSessionInput!) {
    rejectTestSession(inputData: $inputData) {
      id
    }
  }
`
